<template lang="pug">
  #SiteRental
    v-card(width="100%" height="400",dark )
      v-img(src="../../assets/img/background/Brick-Texture.jpg" height="100%" style="margin-top:-85px" )
        v-row(align="center" style="height:100%")
          v-col(cols="12" align="center")
            .display-2.font-weight-black.rental-title Facility & Site Rental
    v-container()
      v-row()
        v-col(cols="12")
          v-img.float-sm-left.mr-8.mb-8(src="../../assets/img/facility/img-2465.jpg" width="460" )
          p.body-1 City of Refuge UCC operates as a California non-profit corporation. We are actively seeking out organizations and individuals who would like to rent spaces in our building.
          p.body-1 We have contracts with union organizations and non-profits for long-term renting. We also have rented space for dozens of private events from weddings to birthday parties, rehearsals, movie screenings, small and large conferences.
          p.body-1 Additionally, we have a dining hall, catering kitchen, meeting rooms, and office space available.
          p.body-1 We prefer that you complete the Rental Request Form below if you have inquires. You may also call or email 
            span.font-weight-bold our Facilities Manager: Tony Lewis at (510) 633-6316 ext. 105 
            | with questions or to arrange a site walk-through.
      //- Site Rental Menu
      v-card.my-5.primary.pa-5( dark width="100%"  )
        v-row.accent.pa-1(no-gutters align="center" justify="center")
          v-col.pa-0(cols="2" align="center" style="max-width:30px ")
            v-btn.scrollBtns(v-if="showScrollBtn" 'icon' @click="onScrollLeft")
                v-icon.mdi.mdi-code-less-than(color="info" large )
          v-col.pa-0(cols="9" )
            v-toolbar#theToolbar.text-center(color="accent" width="100%" flat dark,v-resize="toolBarSize")
              v-spacer
              v-toolbar-items()
                v-divider.mx-1(vertical inset)
                v-btn(:class="{'v-btn--active': showRate}" text @click="showThis('Rate')" ) Rental Rate
                v-divider.mx-1(vertical inset)
                v-btn(:class="{'v-btn--active': showAmenities}" text @click="showThis('Amenities')" ) Amenities
                v-divider.mx-1(vertical inset)
                v-btn(:class="{'v-btn--active': showHours}" text @click="showThis('Hours')" ) Hours
                v-divider.mx-1(vertical inset)
                v-btn(:class="{'v-btn--active': showRestrictions}" text @click="showThis('Restrictions')" ) Restriction
                v-divider.mx-1(vertical inset)
                v-btn(:class="{'v-btn--active': showExpectations}" text @click="showThis('Expectations')" ) Expectation
                v-divider.mx-1(vertical inset)
              v-spacer
          v-col.pa-0(cols="2" style="max-width:30px ")
            v-btn.scrollBtns(v-if="showScrollBtn" 'icon' @click="onScrollRight")
                v-icon.mdi.mdi-code-greater-than(color="info"  large )
        //- Site Rental Individual Information
        v-row(justify="center")
          v-col(cols="12")
            v-card(light width="100 5" color="accent" height="300")
              //- Site Rental
              v-card-text.pa-3(v-if="showRate")
                .title Rental Rate
                ul
                  li For private events we charge a fixed rate, which varies depending on the day of the week and the month of the year.
                  li.font-weight-bold Events run by 
                    u non-profit groups
                    |  get a discount.
                  li Deposit due (30% of total rental) at time of contract signing.
                  li Total amount must be paid seven (7) days before the event.
                br
                .title.font-weight-black RATE INCLUDES:
                .body-1 The final estimate includes the rental rate PLUS use of the space, use of our cushioned or plastic chairs, use of our folding tables, use of our sound or light systems, an event tech to run sound or light on the day, and an event manager to coordinate everything on the facilities' side. 
              //- Amenities
              v-card-text(v-if="showAmenities")
                .title Facility Amenities
                ul
                  li The Auditorium does have a professional grade sound system, along with stage lights, projector and screen, microphones with stands and sound cables.
                  li If you require more in-depth information we would be glad to put you in touch with our Tech Director. Please note we do have wireless microphones as well.
                  li The dining hall and auditorium have LCD projectors with screens and Wi-Fi connections. Some of our meeting rooms have whiteboards.
              //- Hours
              v-card-text(v-if="showHours")
                .title Hours of Operation
                ul
                  li The Facilities Manager is available to show the building Monday through Wednesday from 11am-4pm.
                  li Based on zoning and licensing from the county of Alameda, events must end by 11:00pm, with the public out a half hour earlier.
                  li Our building is occupied every Sunday from 9am to 5pm.
              //- Restrictions
              v-card-text(v-if="showRestrictions")
                .title Please Respect the Following Restrictions for Your Rental:
                ul
                  li The renter may use the stove's oven but not the range.
                  li NO ALCOHOLIC BEVERAGES or illegal substances allowed on the premises at any time. Violation of this provision cancels our agreement and forfeits any monies paid. We cannot do a full liquor service. Events cannot bring in their own alcohol.
                  li You can bring in any prepared food (from a caterer, restaurant, supermarket, deli etc.). There’s no fee or restricted list of caterers, but we would need to talk to you in advance to make sure you can work within the constraints of the venue.
                  li Sales of beverages, candy, and food items shall not be permitted without the express permission of The City of Refuge UCC and at no time can there be food, candy, and beverages (water excepted) in the sanctuary. 
                  li We are obligated to assign one (1) staff member for every 50 members of your party on site.
              //- Expectations
              v-card-text(v-if="showExpectations")
                .title We Expect the Following While You are Renting Our Space:
                ul
                  li Just as in hiking, we believe in the adage - "Leave No Trace."
                  li We expect that you will set up and clean up your event, leaving the space clean and in good repair.
                  li Oakland’s Waste Management policies require separating trash, recycling materials and composting the garbage. Therefore, any RENTER under contract with COR shall be required to do the same.
      //- /** Previous Events Gallery */
      v-card.my-5.lightenSecondary.pa-5(dark)
       .display-1 Gallery Images of Previous Events
       v-row(justify="center")
         v-col(cols="12" align="center")
          v-sheet.pa-2(color="info" width="100%"  style="max-width:500px")
            v-carousel(hide-delimiter-background delimiter-icon="mdi-circle-medium" show-arrows-on-hover)
              v-carousel-item(v-for='(slide,i) in eventsSlides' :key='i' :src='slide.src' reverse-transition='fade-transition' transition='fade-transition' )
      v-row(justify="center")
        v-col(cols="12" md="4" align="center")
          v-card(flat)
            v-img.facilities.white--text.align-end( src="../../assets/img/facility/Auditorium.jpg" height="200"  )
              v-card-title
                .display-1.font-weight-black Auditorium
            v-card-text.text--black
              | Our auditorium serves as the church's sanctuary on Sundays. It holds approximately 300 people seated. It is perfect for a large lecture, movie screening or party space.
        v-col(cols="12" md="4" align="center")
          v-card(flat)
            v-img.facilities.white--text( src="../../assets/img/facility/Kitchen.jpg" height="200"  )
              v-card-title
                .display-1.font-weight-black Kitchen
            v-card-text.text--black
              | Our newly renovated kitchen includes double sinks, an oven and several refrigerators. You may use the space to rewarm food for your event, or call on our Hospitality Services to assist.
        v-col(cols="12" md="4" align="center")
          v-card(flat)
            v-img.facilities.white--text.align-end( src="../../assets/img/facility/DiningHall.jpg" height="200"  )
              v-card-title
                .display-1.font-weight-black Dining Hall
            v-card-text.text--black
              | Our Dining Hall holds 100 people. It is often the main meeting room for conferences or reception for weddings. It's located next to the kitchen and has a projector.
        v-col(cols="12" md="4" align="center")
          v-card(flat)
            v-img.facilities.white--text.align-end( src="../../assets/img/facility/MeetingRoom.jpg" height="200"  )
              v-card-title
                .display-1.font-weight-black Meeting Rooms
            v-card-text.text--black
              | We have various meeting rooms available for conference space and small gatherings. Inquire further for the specific rooms and contents.
        v-col(cols="12" md="4" align="center")
          v-card(flat)
            v-img.facilities.white--text( src="../../assets/img/facility/Security.jpg" height="200"  )
              v-card-title
                .display-1.font-weight-black Security
            v-card-text.text--black
              | Our facility has several live security cameras, an alarm and a gated parking lot.
        v-col(cols="12" md="4" align="center")
          v-card(flat)
            v-img.facilities.white--text.align-end( src="../../assets/img/facility/Parking.jpg" height="200"  )
              v-card-title
                .display-1.font-weight-black Parking
            v-card-text.text--black
              | Our parking lot, located to the side and the rear of our building has 100 parking spaces.
      //- /** Facility Request Form */
      v-row(justify="center")
        v-col(cols="12")
          RequestForm
              
                  
</template>

<script>
import axios from 'axios';
import RequestForm from './request-form';
export default {
  components: {
    RequestForm
  },
  data() {
    return {
      showRate: true,
      showAmenities: false,
      showHours: false,
      showRestrictions: false,
      showExpectations: false,
      showScrollBtn: false,
      eventsSlides: [
        { src: require('../../assets/img/eventsSlides/20160702-194104-1.jpg') },
        {
          src: require('../../assets/img/eventsSlides/resized-20160625-130533.jpg')
        },
        {
          src: require('../../assets/img/eventsSlides/resized-20160625-130623.jpg')
        },
        {
          src: require('../../assets/img/eventsSlides/resized-20160625-191315.jpg')
        },
        {
          src: require('../../assets/img/eventsSlides/resized-20160625-191350.jpg')
        },
        {
          src: require('../../assets/img/eventsSlides/resized-20160625-210400.jpg')
        },
        {
          src: require('../../assets/img/eventsSlides/resized952016062295201157.jpg')
        },
        {
          src: require('../../assets/img/eventsSlides/resized952016062295201255.jpg')
        },
        {
          src: require('../../assets/img/eventsSlides/resized952016062595130414_1.jpg')
        },
        {
          src: require('../../assets/img/eventsSlides/resized952016062595143352.jpg')
        }
      ]
    };
  },
  methods: {
    toolBarSize() {
      let width = document.getElementById('theToolbar').clientWidth;
      if (width < 752) {
        this.showScrollBtn = true;
      } else {
        this.showScrollBtn = false;
      }
    },
    showThis(item) {
      switch (item) {
        case 'Rate':
          this.allFalse();
          this.showRate = true;
          break;
        case 'Amenities':
          this.allFalse();
          this.showAmenities = true;
          break;
        case 'Hours':
          this.allFalse();
          this.showHours = true;
          break;
        case 'Restrictions':
          this.allFalse();
          this.showRestrictions = true;
          break;
        case 'Expectations':
          this.allFalse();
          this.showExpectations = true;
          break;
        default:
          break;
      }
    },
    allFalse() {
      this.showRate = this.showAmenities = this.showHours = this.showRestrictions = this.showExpectations = false;
    },
    onScrollLeft() {
      document.getElementById('theToolbar').scrollLeft -= 20;
    },
    onScrollRight() {
      document.getElementById('theToolbar').scrollLeft += 20;
    },
    onOverflow(e) {
      console.log('onOverflow -> e', e);
    }
  }
};
</script>

<style lang="stylus" scoped>
#theToolbar
  overflow-x hidden
  // overflow-x auto
  overflow-y hidden
  border 1px solid var(--v-primary-base) !important

.facilities
  max-width 500px

.lightenSecondary
  background-color var(--v-secondary-lighten4)

.checkBox.v-input__slot
  margin-bottom 0

.timePicker
  // width 150px

.displayNo
  display none

div.v-toolbar__content
  padding 0 !important

.center
  text-align center

.scrollBtns
  // width 5px
  // background-color info !important

.theme--dark.v-divider
  // border-color rgba(255, 255, 255, 0.75) !important
  border-color var(--v-primary-base) !important

.rental-title
  background-color rgb(125, 51, 22)
  color #fff
  font-family Cardo, 'san-serif' !important
  line-height 65px
</style>
